<template>
    <div class="home-card">
        <div class="title" @click="clickTitle">{{ title }}</div>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'HomeCard',
    props: {
        title: {
            type: String,
            default: '',
        },
    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {

    },
    mounted() {

    },
    methods: {
        clickTitle() {
            this.$emit('clickTitle');
        },
    },
};
</script>
<style lang='less' scoped>
.home-card {
    padding: 24px;
    .title {
        display: inline-block;
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: 16px;
        font-weight: 600;
        color: #161C24;
    }
}

</style>
